/*
  MELT — filtro de tamanho mostra só o que está disponível nesse tamanho.
  Quando a cliente marca um tamanho (ou outra opção de variante), junta-se sozinho o filtro
  "Disponível" (filter.v.availability=1). O Shopify combina os dois na MESMA variante,
  por isso aparecem só os produtos que têm aquele tamanho em stock.
  Corre na fase de captura, antes do tema ler o formulário, e não recarrega a página.
*/
(function () {
  var KEY = 'meltAutoAvailability';
  var NAME = 'filter.v.availability';

  function store(v) { try { if (v) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); } catch (e) {} }
  function stored() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }

  function hasOption(form) {
    return !!form.querySelector('input[name^="filter.v.option."]:checked');
  }
  function availabilityBox(form) {
    return form.querySelector('input[type="checkbox"][name="' + NAME + '"][value="1"]');
  }
  function hidden(form) {
    return form.querySelector('input[type="hidden"][data-melt-auto-availability]');
  }

  function sync(form) {
    if (!form) return;
    var want = hasOption(form);
    var box = availabilityBox(form);
    var h = hidden(form);
    if (want) {
      if (box) {
        if (!box.checked) { box.checked = true; store(true); }
        if (h) h.remove();
      } else if (!h) {
        h = document.createElement('input');
        h.type = 'hidden'; h.name = NAME; h.value = '1';
        h.setAttribute('data-melt-auto-availability', '');
        form.appendChild(h);
        store(true);
      }
    } else {
      if (h) h.remove();
      if (box && box.checked && stored()) box.checked = false;
      store(false);
    }
  }

  function onPick(e) {
    var el = e.target;
    if (!el || !el.name) return;
    var form = el.form || (el.closest && el.closest('form'));
    if (!form) return;
    if (el.name === NAME) {
      /* a cliente mexeu ela própria no "Disponível": deixa de ser automático */
      if (e.isTrusted) store(false);
      return;
    }
    if (el.name.indexOf('filter.v.option.') !== 0) return;
    sync(form);
  }
  /* "input" e "change": o tema pode ler o formulário em qualquer um dos dois */
  document.addEventListener('input', onPick, true);
  document.addEventListener('change', onPick, true);

  /* Também antes de submeter (formulários sem AJAX / botão "Aplicar") */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.querySelector && form.querySelector('input[name^="filter."]')) sync(form);
  }, true);
})();
